import {LoginResponse} from '../types';

export async function RedirectHandler(value: LoginResponse): Promise<void> {
	location.href = value.validation.url;
}
